import { Menu, Transition } from '@headlessui/react';
import type { ComponentProps } from 'react';
import { Fragment } from 'react';

import { FilterButton } from '~modules/media-library/view/FilterDropdown/FilterButton';
import { FilterMenuPanel } from '~modules/media-library/view/FilterDropdown/FilterMenuPanel';

type FilterDropdownProps = Pick<
  ComponentProps<typeof FilterMenuPanel>,
  'onItemClick' | 'onClear' | 'labelClear' | 'selected' | 'involvedFilterGroups'
> & {
  options: ComponentProps<typeof FilterMenuPanel>['items'];
  label: string;
  disabled?: boolean;
};

export function FilterDropdown({
  label,
  options = [],
  disabled = false,
  selected = [],
  ...FilterMenuPanelProps
}: FilterDropdownProps) {
  return (
    <Menu as="div" className="ml--filter-dropdown relative inline-block">
      <Menu.Button as={FilterButton} count={selected.length || 0} disabled={disabled}>
        {label}
      </Menu.Button>
      {!disabled && (
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute left-0 mt-2 min-w-56 origin-top-left outline-none z-30">
            <FilterMenuPanel items={options} selected={selected} {...FilterMenuPanelProps} />
          </Menu.Items>
        </Transition>
      )}
    </Menu>
  );
}
